<template>
  <div id="selections_page" class="w-19/20 mx-auto text-left h-full">
    <div v-if="!activeSelection" id="top_bar"
         class="w-full h-1/20 flex justify-between items-center">
      <div class="flex subnav text-xl">
        <p :class="{'border-b-4 border-classen__primary':openedTab === 0}" class="cursor-pointer"
           @click="openedTab = 0">
          {{ getTranslation('all') }}
        </p>
        <p :class="{'border-b-4 border-classen__primary':openedTab === 1}"
           class="ml-3 cursor-pointer"
           @click="openedTab = 1">
          {{ getTranslation('mySelections') }}
        </p>
        <p :class="{'border-b-4 border-classen__primary':openedTab === 2}"
           class="ml-3 cursor-pointer"
           @click="openedTab = 2">
          {{ getTranslation('customerSelections') }}
        </p>
      </div>
      <button v-if="canAdd()" @click="addSelection"
              class="float-right classen__button classen__button_active">
        <p class="leading-none">+ {{ getTranslation('addSelection') }}</p>
      </button>
    </div>
    <div v-if="!activeSelection" id="search" class="w-full h-1/20">
      <input v-model="searchInput" type="text" :placeholder="getTranslation('search')"
             class="border-shadow rounded-20 search float-left mt-2 mb-2 pl-2">
    </div>
    <div v-if="!activeSelection" id="selections_div" class="h-9/10 mt-1">
      <div
        class="grid grid-cols-smallSelectionTable 1.5xl:grid-cols-selectionTable font-bold h-1/20 border-b-2 border-classen__secondary">
        <p class="self-center cursor-pointer" @click="sortByColumn('name')">
          {{ getTranslation('name') }}
          <font-awesome-icon icon="sort"/>
        </p>
        <p class="self-center cursor-pointer" @click="sortByColumn('creator')">
          {{ getTranslation('createdBy') }}
          <font-awesome-icon icon="sort"/>
        </p>
        <p class="self-center">{{ getTranslation('logo') }}</p>
        <p class="self-center cursor-pointer hidden 1.5xl:block" @click="sortByColumn('updatedAt')">
          {{ getTranslation('lastUpdated') }}
          <font-awesome-icon icon="sort"/>
        </p>
        <p class="self-center text-right">{{ getTranslation('actions') }}</p>
      </div>
      <div class="h-19/20 overflow-y-auto">
        <div v-for="selection in filteredSelections"
             class="grid grid-cols-smallSelectionTable 1.5xl:grid-cols-selectionTable selection border-b border-classen__secondary items-center"
        >
          <p class="w-full overflow-hidden whitespace-nowrap overflow-ellipsis pr-2">
            <label v-show="selection.type === 'private'"><i class="fas fa-lock"></i></label>
            {{ selection.name }}
          </p>
          <p v-if="selection.owner" class="overflow-hidden whitespace-nowrap overflow-ellipsis">
            {{ selection.owner.email }}</p>
          <img v-if="selection.logo !== '' && selection.logo !== null" :src="selection.logo"
               class="logo"
               alt="logo"/>
          <p v-else></p>
          <p class="hidden 1.5xl:block">{{ toDate(selection.updatedAt) }}</p>
          <div class="flex justify-end text-center text-white">
            <div class="action bg-classen__primary" @click="viewOrEdit(selection)"
                 v-if="canSeeEditViewButton">
              <i v-show="canEdit(selection)" class="fas fa-pen"></i>
              <i v-show="!canEdit(selection)" class="fas fa-eye"></i>
            </div>
            <div v-if="canDuplicate()" class="ml-2 action bg-classen__primary"
                 @click="duplicateSelection(selection.id)"><i
              class="fas fa-copy"></i></div>
            <div v-if="canDelete(selection)" class="ml-2 action bg-classen__primary"
                 @click="itemToDelete = selection">
              <i class="fas fa-trash"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <c-view-selection v-if="activeSelection" :selection="activeSelection"
                      @onClose="activeSelection=null"
                      :allowEdit="canEdit(activeSelection)"
                      :allowEditType="canEditType(activeSelection)"
                      :allowDelete="canDelete(activeSelection)"
                      :sharePermissions="getSharePermissions()"
                      :actionPermissions="getActionPermissions()"/>

    <c-popup-confirm
      v-if="itemToDelete"
      :phrase="getTranslation('areYouSureYouWantToDeleteThis')"
      :confirm-text="getTranslation('yesDeleteSelection')"
      :cacnel-text="getTranslation('cancel')"
      @confirm="onConfirm"
      @cancel="onCancel"
    />

    <c-loader v-if="!isLoaded"></c-loader>
  </div>
</template>

<script>

import getTranslation from "../mixins/getTranslation";
import dateConversion from "../mixins/dateConversion";
import ViewSelection from "../components/structure/Selections/ViewSelection";
import ConfirmationPopup from "../components/form/ConfirmationPopup";
import Loader from "../components/Loader";
import getPermissions from "../mixins/getPermissions";

export default {
  name: 'Selections',

  components: {
    'c-view-selection': ViewSelection,
    'c-popup-confirm': ConfirmationPopup,
    'c-loader': Loader
  },

  created() {
    document.title = 'The Qube - Selections'
  },

  mixins: [getTranslation, dateConversion, getPermissions],

  data() {
    return {
      searchInput: '',
      isLoaded: true,
      activeSelection: null,
      openedTab: 0,
      itemToDelete: null,

      sortBy: {
        name: true,
        creator: true,
        updatedAt: true,
      },
    }
  },

  computed: {
    canSeeEditViewButton() {
      return this.canViewSelection || this.canEditSelection
    },

    activeUser() {
      return this.$dashboardStore.getters.getActiveUser();
    },

    selections() {
      let selections = this.$dashboardStore.getters.getSelections;
      if (this.activeUserHasRole(this.ROLES.SALES_ADMIN)) {
        selections = selections.filter((selection) => selection.type !== 'public');
      }

      return selections;
    },

    selectionsToDisplay() {
      if (this.openedTab === 0) {
        return this.selections
      }

      if (this.openedTab === 1) {
        return this.selections.filter((selection) => {
          return selection.ownerId === this.activeUser.id
        })
      }

      if (this.openedTab === 2) {
        return this.selections.filter((selection) => {
          return selection.type === 'client'
        })
      }
    },

    filteredSelections() {
      return this.selectionsToDisplay.filter((selection) => {
        if (!selection.name) {
          return true
        }

        return selection.name.toLowerCase().includes(this.searchInput.toLowerCase()) && selection.id !== -1;
      })
    }
  },

  methods: {
    sortByColumn(column) {
      if (column === 'name') {
        this.sortAlphabetical(column);
        return;
      }

      if (column === 'creator') {
        this.sortByCreator();
        return;
      }

      if (column === 'updatedAt') {
        this.sortByUpdated();
      }
    },

    sortByUpdated() {
      this.selections.sort((a, b) => {
        return new Date(b.updatedAt) - new Date(a.updatedAt);
      })
      this.reverseArrayIfNecessary('updatedAt');
    },

    sortByCreator() {
      this.selections = this.selections.sort((a, b) => {
        if (a.id === -1 || b.id === -1) {
          return -1;
        }

        return a.owner.email.localeCompare(b.owner.email)
      });
      this.reverseArrayIfNecessary('creator');
    },

    sortAlphabetical(column) {
      this.selections = this.selections.sort((a, b) => a[column].localeCompare(b[column]));
      this.reverseArrayIfNecessary(column);
    },

    reverseArrayIfNecessary(column) {
      if (!this.sortBy[column]) {
        this.selections = this.selections.reverse();
      }

      this.sortBy[column] = !this.sortBy[column];
    },

    addSelection() {
      this.isLoaded = false;
      let selection = {name: 'New selection', memo: "", type: 'private'}
      this.$dashboardStore.dispatch('addSelection', selection)
        .then((res) => {
          const selection = res.data;
          selection.isNew = true;
          this.$dashboardStore.commit('ADD_SELECTION', selection);
          this.activeSelection = selection;
          this.isLoaded = true;
        })
        .catch((e) => {
          console.warn('An error occurred creating a selection', e)
          this.isLoaded = true;
        })
    },

    viewOrEdit(selection) {
      this.activeSelection = selection;
    },

    duplicateSelection(selectionId) {
      this.$dashboardStore.dispatch('duplicateSelection', selectionId)
        .then((res) => {
          this.$dashboardStore.commit('ADD_SELECTION', res.data)
        })
    },

    onCancel() {
      this.itemToDelete = null
    },

    onConfirm() {
      this.$dashboardStore.dispatch('deleteSelection', this.itemToDelete.id)
        .then((res) => {
          if (res.response !== 'success') {
            return
          }

          this.itemToDelete = null;
          this.$dashboardStore.dispatch('forceReloadSelections');
        })
    },

    canAdd() {
      return this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN, this.ROLES.SALES_ADMIN])
        || this.flexibleHasSelectionPermissionTo(this.SELECTIONS_PERMISSIONS.ADD);
    },

    canEdit(selection) {
      let sharedWithActiveUser = false;
      if (selection && selection.sharedWith) {
        sharedWithActiveUser = selection.sharedWith.filter((user) => user.id === this.activeUser.id).length > 0;
      }

      return this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.SALES_ADMIN])
        || (this.activeUserHasRole(this.ROLES.REGIONAL_ADMIN) && sharedWithActiveUser)
        || (this.activeUserHasRole(this.ROLES.SALES_ADMIN) && sharedWithActiveUser)
        || (this.flexibleHasSelectionPermissionTo(this.SELECTIONS_PERMISSIONS.EDIT) && sharedWithActiveUser)
        || selection.ownerId === this.activeUser.id;
    },

    canEditType(selection) {
      if ((this.canEdit(selection)
        && this.activeUserHasRoleInRolesArray([this.ROLES.REGIONAL_ADMIN, this.ROLES.SALES_ADMIN, this.ROLES.FLEXIBLE])
        && selection.ownerId !== this.activeUser.id)) {
        return false;
      }
      return this.canEdit(selection);
    },

    canDelete(selection) {
      return this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN])
        || selection.ownerId === this.activeUser.id;
    },

    canDuplicate() {
      return this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN, this.ROLES.SALES_ADMIN]);
    },

    getSharePermissions() {
      return {
        regions: this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN]),
        regionalAdmins: this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN]),
        salesAdmins: this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN, this.ROLES.SALES_ADMIN]),
        flexible: this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN, this.ROLES.SALES_ADMIN])
      };
    },

    getActionPermissions() {
      return {
        requestHRImages: this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN, this.ROLES.SALES_ADMIN]) || this.flexibleHasSelectionPermissionTo(this.SELECTIONS_PERMISSIONS.REQUEST_IMAGES),
        generateSharedLink: this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN, this.ROLES.SALES_ADMIN]) || this.flexibleHasSelectionPermissionTo(this.SELECTIONS_PERMISSIONS.SHARED_LINK),
        generateExcelFile: this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN, this.ROLES.SALES_ADMIN, this.ROLES.EXTERNAL]) || this.flexibleHasSelectionPermissionTo(this.SELECTIONS_PERMISSIONS.EXCEL),
        generatePdf: this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN, this.ROLES.REGIONAL_ADMIN, this.ROLES.SALES_ADMIN, this.ROLES.EXTERNAL]) || this.flexibleHasSelectionPermissionTo(this.SELECTIONS_PERMISSIONS.PDF),
        embed: this.activeUserHasRoleInRolesArray([this.ROLES.MASTER_ADMIN, this.ROLES.ADMIN])
      };
    },
  }
}
</script>

<style scoped>
.subnav {
  line-height: 35px;
  height: 35px;
}

.classen__button {
  height: 35px;
}

.search {
  width: 200px
}

.selection {
  height: 90px;
  line-height: 90px;
}

.action {
  height: 40px;
  width: 40px;
  line-height: 40px;
  border-radius: 40px;
}

.logo {
  border: none;
  width: 200px;
  height: 85px;
  object-fit: contain;
}
</style>
